import axios from "axios";

export default {
    namespaced: true,
    state: {
        processRequestCount: 0, // if > 0 loader will show
        topBar: {},
        bottomBar: {},
        businessId: 1329,//948
        groupId: 149,//40
        gatewayInfo: null, // {gateway_id: 214, account_id: "100170642782", secret_key: "CALMJ8T6Y8LLLA5LA9LF7VF1V9QVAQWE"}
        guest_id: null,
        alert: null
    },
    mutations: {
        requestCount(state, val) {
            state.processRequestCount += val;
        },
        setAlert(state, val) {
            state.alert = val;
        },
        setBusinessId(state, val) {
            state.businessId = val;
        },
        setTopBar(state, val) {
            //Defaults
            const newVals = {
                active: true,
                title: "",
                showBag: false,
                showShadow: false,
                showX: false,
                showAddressTime: false,
                showBackButton: false,
                showLocationSearch: false,
                bgColor: null,
                smallText: false,
                ...val
            };
            if (window.ga) {
                let googleAnalyticTitle = newVals.title ? newVals.title : "unknown";
                window.ga.trackView(googleAnalyticTitle);
            }
            state.topBar = newVals;
        },
        setGuestId(state,val){
            state.guest_id= val
        },
        setGatewayInfo(state, val) {
            state.gatewayInfo = val;
        }
    },
    actions: {
        getGatewayInfo(store, {callback, giftcardTypeId} = {giftcardTypeId:null}) {
            let url = `/unauth/businesses/${store.state.businessId}/orders/purchase_settings`;
            if (giftcardTypeId){
                const group_id = store.state.groupId
                url = `/unauth/groups/${group_id}/gift_cards/${giftcardTypeId}/purchase_settings`
            }
            axios.get(url).then(res => {
                const data = {...res.data,giftcard:giftcardTypeId};
                //console.log(data);
                store.commit("setGatewayInfo", data);
                store.commit("cart/updateCartDate", null, {root: true});
                callback?.();
            });
        }
    }
}
